import { render } from "./BaseNotecard.vue?vue&type=template&id=d1b3200a"
const script = {}

import "./BaseNotecard.vue?vue&type=style&index=0&id=d1b3200a&lang=scss"

import exportComponent from "C:\\Users\\MK\\Desktop\\paymentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__